import {
  Card,
  CardBody,
  CardBodyProps as ChakraUICardBodyProps,
  AspectRatio,
  Flex,
  Skeleton
} from "@chakra-ui/react";

import { ReactElement, ReactNode } from "react";

import { Image } from "@/storybook-components/image/image";
import { PinDetails } from "./pin-details/pin-details";
import { Tile } from "./tile/tile";
import { Description } from "./description/description";

export interface CardBodyProps extends ChakraUICardBodyProps {
  imageSrc?: string;
  imageAlt?: string;
  cardHeading?: string;
  cardDescription?: string | ReactNode;
  showDescription?: boolean;
  pinType?: string;
  pinAddress?: string;
  pinIcon?: ReactElement;
  cardVariant?: string;
  showDetailedText?: boolean;
  tileBackgroundColor?: string;
  showImage?: boolean;
  isLoaded?: boolean;
  hasBodyHighlight?: boolean;
  pinColor?: string;
  username?: string;
  userAvatarSrc?: string;
  contributionTime?: string;
  pinImageSrc?: string;
  handleOnBodyClick?: any;
  isAddressVisible?: boolean;
  dataElement?: any;
  magnifiedImage?: boolean;
  isCursor?: boolean;
  numberOfLines?: number;
}

export function Body(props: CardBodyProps) {
  const {
    imageSrc,
    imageAlt,
    cardHeading,
    showDescription,
    cardDescription,
    pinType,
    pinAddress,
    pinColor,
    pinIcon,
    cardVariant,
    showDetailedText,
    tileBackgroundColor,
    showImage,
    isLoaded,
    hasBodyHighlight,
    username,
    userAvatarSrc,
    contributionTime,
    pinImageSrc,
    handleOnBodyClick,
    isAddressVisible,
    dataElement,
    magnifiedImage,
    isCursor,
    numberOfLines
  } = props;
  const isMagnifyImage = showDetailedText && !!imageSrc;

  return (
    <Card
      boxShadow="none"
      flexGrow={1}
      bgColor={cardVariant === "elevated" ? "whiteAlpha.100" : "transparent"}
      cursor={isCursor ? "pointer" : "default"}
    >
      <CardBody
        px={cardVariant === "elevated" ? 2 : 0}
        py={0}
        className={hasBodyHighlight ? "" : "no-highlight"}
        onClick={handleOnBodyClick}
        cursor="pointer"
      >
        <Flex direction="column" gap={2}>
          {showImage && imageSrc && cardVariant === "unstyled" && (
            <Skeleton isLoaded={isLoaded} minW="full">
              <AspectRatio ratio={16 / 9}>
                <Image
                  minW="full"
                  objectFit="cover"
                  borderRadius="lg"
                  src={imageSrc}
                  alt={imageAlt}
                  magnify={isMagnifyImage}
                  viewWithHeader={isMagnifyImage}
                  isLoaded
                  username={username}
                  userAvatarSrc={userAvatarSrc}
                  contributionTime={contributionTime}
                  magnifiedImage={magnifiedImage}
                  isCursor={isCursor}
                  cursor="pointer"
                />
              </AspectRatio>
            </Skeleton>
          )}
          {!imageSrc && showImage && cardVariant !== "elevated" && (
            <AspectRatio
              ratio={16 / 9}
              minH={showDescription && cardDescription ? "162px" : "265px"}
            >
              <Tile
                cardVariant={cardVariant}
                cardDescription={cardDescription}
                cardHeading={cardHeading}
                showDescription={showDescription}
                tileBackgroundColor={tileBackgroundColor}
                isLoaded={isLoaded}
              />
            </AspectRatio>
          )}
          {(pinType || pinAddress) && (
            <PinDetails
              isAddressVisible={isAddressVisible}
              pinAddress={pinAddress}
              pinType={pinType}
              isLoaded={isLoaded}
              pinColor={pinColor}
              pinImageSrc={pinImageSrc}
              pinIcon={pinIcon}
            />
          )}
          <Description
            imageSrc={imageSrc}
            cardHeading={cardHeading}
            cardDescription={cardDescription}
            showDescription={showDescription}
            showDetailedText={showDetailedText}
            isLoaded={isLoaded}
            numberOfLines={numberOfLines}
          />
          {dataElement ? dataElement : null}
        </Flex>
      </CardBody>
    </Card>
  );
}
